import { FILE_EXTENSION_PNG } from '../../../constants/file'
import { getFileNameWithExtension, getSafeFileName } from '../../../utils/file'
import { getUserListItemContentName } from '../../../utils/user'

import { DOC_FLOW_EPOST_VALIDATION_PREVIEW_FILE_NAME_SEPARATOR } from './DocFlowEpostValidationPreviewModal.constants'

export function getDocFlowEpostValidationPreviewFileName({
  docFlowName,
  recipient,
}) {
  const name = [
    docFlowName,
    getUserListItemContentName(recipient?.email, recipient?.fullname),
  ]
    .filter(Boolean)
    .map(getSafeFileName)
    .filter(Boolean)
    .join(DOC_FLOW_EPOST_VALIDATION_PREVIEW_FILE_NAME_SEPARATOR)

  return getFileNameWithExtension(name, FILE_EXTENSION_PNG)
}
